import type { SectionTabItem } from '../components/SectionTabs';

/**
 * Top-level section tab definitions. Centralized here so SectionTabs callers and
 * the navbar dropdown menus stay in sync.
 *
 * Admin / back-office pages no longer use a tab strip — they use the
 * `AdminLayout` sidebar (see `lib/admin-nav.ts`). Only the public-facing
 * sections (Events, Venues, Series, Submit) have section tabs.
 */

export const EVENTS_TABS: SectionTabItem[] = [
  { to: '/events', label: 'List', end: true },
  { to: '/events/calendar', label: 'Calendar' },
  { to: '/events/map', label: 'Map' },
  { to: '/events/my-taste', label: 'My taste' },
  { to: '/events/calendar-posts', label: 'Calendar posts' },
  { to: '/events/on-view', label: 'On view' },
  { to: '/events/queue', label: 'Events Review Queue', groupStart: 'Admin', adminOnly: true },
  { to: '/events/manage', label: 'Manage events', adminOnly: true },
];

export const VENUES_TABS: SectionTabItem[] = [
  { to: '/venues', label: 'List', end: true },
  { to: '/venues/map', label: 'Map' },
  { to: '/venues/manage', label: 'Manage venues', groupStart: 'Admin', adminOnly: true },
  { to: '/venues/pending', label: 'Pending venues', adminOnly: true },
];

export const SERIES_TABS: SectionTabItem[] = [
  { to: '/series', label: 'List', end: true },
  { to: '/series/map', label: 'Map' },
  { to: '/series/manage', label: 'Manage series', groupStart: 'Admin', adminOnly: true },
];

export const SUBMIT_TABS: SectionTabItem[] = [
  { to: '/submit', label: 'Submit an event', end: true },
  { to: '/submit/mine', label: 'My submissions' },
  { to: '/submit/history', label: 'Submissions history', groupStart: 'Admin', adminOnly: true },
  { to: '/submit/request-change', label: 'Request a change', adminOnly: true },
];
